import { useState } from "react";
import "../styles/portal/Signin.css";
import { NavLink } from "react-router-dom";

function Signup() {
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [cpf, setCPF] = useState('');
    const [phone_number, setPhone] = useState('');
    const [password, setPassword] = useState('');
    const [passwordConf, setPasswordConf] = useState('');
    
    return (
        <div className="signin-container">
            <h3>Novo Usuario</h3>
            <form className="signup-form" onSubmit={() => console.log("oi")}>
                <label>Nome:</label>
                <input
                    type="text"
                    required
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                />
                <label>CPF/CNPJ:</label>
                <input
                    type="text"
                    placeholder="xxx.xxx.xxx-xx"
                    required
                    value={cpf}
                    onChange={(e) => setCPF(e.target.value)}
                />
                <label>E-mail:</label>
                <input
                    type="email"
                    required
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                />
                <label>Telefone:</label>
                <input
                    type="text"
                    name="phone"
                    placeholder="(xx) xxxxx-xxxx"
                    required
                    value={phone_number}
                    onChange={(e) => setPhone(e)}
                />
                <label>Senha:</label>
                <input
                    type="password"
                    required
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                />
                <label>Confirmar Senha:</label>
                <input
                    type="password"
                    required
                    value={passwordConf}
                    onChange={(e) => setPasswordConf(e.target.value)}
                />
                <input type="submit" value="Registrar"></input>
                <label>J´a é registrado?</label>
                <NavLink className="signin-form-navlink" to={"/portal/signin"}>Entre</NavLink>
            </form>
        </div>
    )
}

export default Signup
